module.exports = __webpack_public_path__ + "img/admin-wallet-ledger.99c9de0b.png";